import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';


export interface SentimentGrouped {
  date: string;
  sentiment: "Negative" | "Neutral" | "Mixed" | "Positive";
  count: number;
}

export interface TrendGrouped {
  date: string;
  isTrend: boolean;
  count: number;
}

export interface CompetitorActivityGrouped {
  date: string;
  isCompetitorActivity: boolean;
  count: number;
}

export interface MarketSentimentGrouped {
  date: string;
  isMarketSentiment: boolean;
  count: number;
}

export interface RegulatoryChangeGrouped {
  date: string;
  isRegulatoryChange: boolean;
  count: number;
}

export interface SentimentAnalysisData {
  sentimentGrouped: SentimentGrouped[];
  trendGrouped: TrendGrouped[];
  competitorActivityGrouped: CompetitorActivityGrouped[];
  marketSentimentGrouped: MarketSentimentGrouped[];
  regulatoryChangeGrouped: RegulatoryChangeGrouped[];
}

export interface Entity {
  name: string;
  type: string;
}

export interface GroupedEntity {
  [type: string]: Entity[];
}

interface EnsigtsArticle {
  aritcleTitle: string; // Title of the article
  newsType: string; // URL of the news source
  aritcleId: string; // Unique identifier for the article
  title: string; // Title of the article (same as aritcleTitle)
  keyPhrases: string[]; // Array of key phrases extracted from the article
  entities: string[]; // Array of entities mentioned in the article
  sentiment: string; // Sentiment of the article (e.g., Positive, Negative)
  isTrend: boolean; // Indicates if it identifies a trend
  isCompetitorActivity: boolean; // Indicates if it's related to competitor activity
  isMarketSentiment: boolean; // Indicates if it reflects market sentiment
  isRegulatoryChange: boolean; // Indicates if it involves regulatory changes
}

@Component({
  selector: 'app-business-insight-dashboard',
  templateUrl: './business-insight-dashboard.component.html',
  styleUrls: ['./business-insight-dashboard.component.css'],standalone:false
})
export class BusinessInsightDashboardComponent {
  news:EnsigtsArticle[]=[];
  loading:boolean=false;
  userId:string
  latestTimestamp!: string;
  notifications!:SentimentAnalysisData
  entities:Entity[]=[]
  logoprovider:string='https://www.france24.com/favicon.ico'
  userRole:string=''
  constructor
   (
     private messageService:MessageService,
     private auth:AuthService,
     private api:BaseApiService,
     private route: ActivatedRoute,
     private sanitizer: DomSanitizer
   ) {
     this.userId=this.auth.getUID();
     this.userRole=this.auth.getRoles().toString()
   }

  GetNotifications(){
    this.loading=true;
    this.api.read("BusinessInsights/GetBusinessInsights").subscribe
    (
      (response)=>{
        this.notifications   = response;
        this.loading         = false;
      }
      ,(
        error
      )=>{

        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )
  }


  GetEntities() {
    this.loading = true;
    this.api.read("BusinessInsights/Getentities").subscribe(
      (response: Entity[]) => {
        this.entities = response;

        // Group the entities by type
        const groupedEntities: GroupedEntity = this.entities.reduce((acc, entity) => {
          if (!acc[entity.type]) {
            acc[entity.type] = []; // Create an array for a new type
          }
          acc[entity.type].push(entity); // Add the entity to the correct type array
          return acc;
        }, {} as GroupedEntity);

        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    );
  }

  GetNotifica(id:string,pageNum:number,pageSize:number)
  {
    this.loading=true;
    this.api.read(`BusinessInsights/GetBusinessInsight?type=${id}&pageNumber=${pageNum}&pageSize=${pageSize}`).subscribe
    (
      (response)=>{
        this.news     = response;
        this.loading  = false;
      }
      ,(
        error
      )=>{

        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )
  }

  ngOnInit() {
    this.GetNotifications();
    this.GetEntities();
    this.GetNotifica("immobilier",1,10)
  }



  getLogo(url:string)
  {
     const con = this.api.getNewsProviderDetails(url)
     if(con){
       this.logoprovider=con.logoUrl;
       return this.logoprovider;
     }
     return this.logoprovider;
  }

  sanitizeHtml(htmlContent: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }

  sanitizeHtmlWithImageFix(html: string) {
    // Create a temporary DOM element to manipulate the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Select the first image element if it exists
    const images = tempDiv.querySelectorAll('img');
    let imageSrc = '';

    if (images.length > 0) {
      // Get the src of the first image
      imageSrc = images[0].src;

      // Remove the image from the description
      images[0].remove();
    }

    // Style remaining images (if any)
    images.forEach((img: HTMLImageElement) => {
      img.style.width = '100%';    // Make the image responsive
      img.style.height = 'auto';   // Maintain aspect ratio
      img.classList.add('rounded-2', 'shadow'); // Optional: Apply additional styling
    });

    // Return both sanitized HTML and image source
    return {
      sanitizedHtml: this.sanitizer.bypassSecurityTrustHtml(tempDiv.innerHTML),
      imageSrc: imageSrc
    };
  }


  getFaviconUrl(rssUrl: string): string {
    try {

      const url    = new URL(rssUrl);
      const domain = url.origin;
      return `${domain}/favicon.ico`;

    } catch (error)
    {
      return 'assets/icons/default-favicon.png';
    }
  }


  getSiteName(url: string): string {
    try {
      // Create a URL object from the provided URL
      const urlObj = new URL(url);

      // Get the hostname (e.g., www.bfmtv.com)
      let hostname = urlObj.hostname;

      // Remove common subdomains like 'www.'
      if (hostname.startsWith('www.')) {
        hostname = hostname.replace('www.', '');
      }

      // Capitalize the first letter of each word to create a clean name
      const siteName = hostname.split('.')[0]; // Take the main part of the domain
      return this.capitalizeWords(siteName); // Capitalize the first letter of the name
    } catch (error) {
      // In case of error, return a default name or an empty string
      return 'Unknown Site';
    }
  }

  // Helper function to capitalize words
  private capitalizeWords(name: string): string {
    return name.charAt(0).toUpperCase() + name.slice(1);
  }

}
